import getImageCrop from "app/media/helpers/getImageCrop";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import getWrapperStyles from "blocks/helpers/getWrapperStyles";
import ImageViewer from "components/ImageViewer/ImageViewer";
import combineClasses from "helpers/combine-classes";
import React, { FunctionComponent } from "react";
import styles from "./Image.module.scss";
import ImageContent from "./ImageContent.model";

const Image: FunctionComponent<ImageContent> = (props) => {
    const wrapperStyles = getWrapperStyles(props.settings);

    // Image Cropping
    // 1. The editor has a "Preferred crop"-setting to override the template default crop.
    // 2. If no crop is given, the Image component fallbacks to focal points.
    // 3. If no focalpoint is given, we fallback to center,center.

    // Image Height Ratio
    // 1. Get HeightRatio of the "Preferred crop"-setting (Fallback to template crop)
    // 2. Get HeightRatio of Original
    // 3. Get HeightRatio of 16:9

    const imageCrop = getImageCrop(props.content.media?.crops, props.content.mediaCrop, "Fullscreen (4:3)");
    const imageAspectRatio = getImageAspectRatio(imageCrop, props.content.media?.width, props.content.media?.height);
    const imageSizeClass = props.content.mediaSize ? styles[props.content.mediaSize] : undefined;

    return (
        <div className={combineClasses([styles.wrapper, ...wrapperStyles, imageSizeClass])}>
            <div className={combineClasses([styles.container, imageSizeClass])}>
                <div className={styles.media}>
                    {/* Media */}
                    {props.content.media ? (
                        <ImageViewer
                            src={props.content.media?.url || props.content.media}
                            crop={imageCrop}
                            focalPoint={props.content.media.focalPoint}
                            {...imageAspectRatio}
                            alt={props.content.mediaAlternate}
                        />
                    ) : null}

                    {/* Caption */}
                    {props.content.mediaCaption && props.content.mediaCaption.length > 0 ? (
                        <div className={styles.caption}>{props.content.mediaCaption}</div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default Image;
